import React from "react";
import { connect } from "react-redux";
import { selectGoals } from "../../actions/";

import WizardStep from "../WizardStep";
import WizardSidebar from "../WizardSidebar";
import goalList from "../../config/goalList";
import "../../css/Goals.scss";

class Goals extends React.Component {
	state = {
		title: "What are your #goals?",
		text:
			"Your business needs will shape the way your program functions, so make sure you select your top objectives.",
		goalsList: goalList
	};

	renderGoalsList = () => {
		return this.state.goalsList.map(goal => {
			return (
				<div
					className={
						"single-goal " +
						(this.props.selectedGoals.indexOf(goal.goalName) > -1
							? "active"
							: "")
					}
					key={goal.goalName}
					onClick={() => {
						this.props.selectGoals(goal.goalName);
					}}>
					<div className="goal-icon">
						<img
							className="icon-default"
							src={goal.goalIcon}
							alt={goal.goalName}
						/>
						<img
							className="icon-filled"
							src={goal.goalIconFilled}
							alt={goal.goalName}
						/>
					</div>
					<div className="goal-description">{goal.goalDescription}</div>
				</div>
			);
		});
	};

	render() {
		return (
			<div className="view goals">
				<WizardSidebar
					title="One size fits all is a myth"
					text={
						<div>
							<p>
								Focus on your brand’s specific needs to build the right Loyalty & Referrals program.
							</p>
							<p>
								While all Loyalty & Referrals programs have a few universal goals, the best programs incentivize actions that matter most to your brand, like decreasing time to second purchase or promoting new product lines.
							</p>
						</div>
					}
					image="step-3"
				/>
				<WizardStep
					title={this.state.title}
					text={this.state.text}
					navigateTo="orders"
					buttonText="Next"
					actionType="Goals"
					disabledButton={
						this.props.selectedGoals.length > 0 ? "" : "disabled"
					}>
					<div className="goals-list">{this.renderGoalsList()}</div>
				</WizardStep>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		selectedGoals: state.goals
	};
};

export default connect(
	mapStateToProps,
	{ selectGoals }
)(Goals);
